import { createControllingOrgWatcher } from '../components/CreateControllingOrg/store/sagas';
import { updateControllingOrgWatcher } from 'modules/settings/submodules/clients/controllingOrg/components/EditControllingOrg/store/sagas';

export const controllingOrgSagas = [
    createControllingOrgWatcher,
    updateControllingOrgWatcher,
];
